import "./plugins";
import "./components/design";

import Vue from "vue";
import Vuetify from "vuetify";
import interceptors from "./services/interceptors";
import store from "./store";
import router from "./router";
import VueCoreVideoPlayer from "./plugins/vue-core-video-player/index";
import i18n from "./plugins/i18n";
import App from "./App.vue";
import {
  getInitialEmbeddedRoute,
  isEmbedded,
  notifyLegacyRouteChange,
} from "./services/embeddedNavigation";

const embeddedParams = new URLSearchParams(window.location.search);
window.__LABSTREAM_EMBEDDED__ = embeddedParams.get("embedded") === "1";

interceptors.setupInterceptors();

Vue.config.productionTip = false;

const vuetifyOptions = {
  lang: {
    t: (key, ...params) => i18n.t(key, params),
  },
  theme: {
    themes: {
      light: {
        primary: "#0d9fea",
        secondary: "#77aa22",
        accent: "#82B1FF",
        error: "#FF5252",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FFC107",
      },
      dark: {
        primary: "#ffffff",
      },
    },
  },
};

new Vue({
  i18n,
  store,
  router,
  vuetify: new Vuetify(vuetifyOptions),
  render: (h) => h(App),
}).$mount("#app");

if (isEmbedded()) {
  if (window.localStorage.getItem("access_token")) {
    store.dispatch("fetchStaticData").catch((err) => {
      console.warn("Unable to load embedded static data", err);
    });
  }

  const normalizeEmbeddedRoute = (path) => {
    if (!path || typeof path !== "string") return null;
    return path.startsWith("/") ? path : `/${path}`;
  };

  window.addEventListener("message", (event) => {
    if (
      event.origin !== window.location.origin ||
      event.source !== window.parent ||
      event.data?.type !== "labstream-host-route-change"
    ) return;

    const targetRoute = normalizeEmbeddedRoute(event.data.path);
    if (targetRoute && router.currentRoute.fullPath !== targetRoute) {
      router.replace(targetRoute).catch(() => {});
    }
  });

  const initialRoute = getInitialEmbeddedRoute();
  router.onReady(() => {
    const targetRoute = normalizeEmbeddedRoute(initialRoute);
    const notifyCurrentRoute = () => notifyLegacyRouteChange(router.currentRoute.fullPath);
    if (targetRoute && router.currentRoute.fullPath !== targetRoute) {
      router.replace(targetRoute).then(notifyCurrentRoute).catch(notifyCurrentRoute);
      return;
    }
    notifyCurrentRoute();
  });
  router.afterEach((to) => notifyLegacyRouteChange(to.fullPath));
}

Vue.use(VueCoreVideoPlayer);
